import React, { useRef } from "react";
import "../styles/filterBar.css";

// Each collection gets one of these earthy palette entries (cycling by index)
const CHIP_PALETTE = [
  { bg: "#1a1a1a", color: "#fff"    },  // "All"
  { bg: "#e8d5b7", color: "#5c3d1e" },  // Beige
  { bg: "#f2c4a8", color: "#7a3b1e" },  // Peach
  { bg: "#c8b49a", color: "#4a3728" },  // Brown
  { bg: "#eeddd4", color: "#6b2d2d" },  // Dusty rose
  { bg: "#f0ece4", color: "#4a4239" },  // Ivory
  { bg: "#d6e8d5", color: "#2d4a2d" },  // Sage
];

export default function FilterBar({ collections = [], activeCollection, setActiveCollection }) {
  const allCollections = ["All", ...collections];
  const scrollRef = useRef(null);

  const handleChipClick = (c, e) => {
    setActiveCollection(c);
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const chipLeft = e.currentTarget.getBoundingClientRect().left
                   - container.getBoundingClientRect().left;
    const nudge    = container.clientWidth * 0.3;
    // Cap nudge so the clicked chip never scrolls off the left edge (keep 8px gap)
    const safeNudge = Math.min(nudge, Math.max(0, chipLeft - 8));
    if (safeNudge > 0) container.scrollBy({ left: safeNudge, behavior: "smooth" });
  };

  return (
    <div className="filter-bar" ref={scrollRef}>
      <div className="filter-bar__chips">
        {allCollections.map((c, i) => {
          const palette = CHIP_PALETTE[i % CHIP_PALETTE.length];
          const isActive = activeCollection === c;
          return (
            <button
              key={c}
              onClick={(e) => handleChipClick(c, e)}
              className={`filter-bar__chip ${isActive ? "filter-bar__chip--active" : ""}`}
              style={{
                background:  palette.bg,
                color:       palette.color,
                borderColor: isActive ? "rgba(0,0,0,0.18)" : "transparent",
              }}
            >
              {c}
            </button>
          );
        })}
      </div>
    </div>
  );
}
